
























import { Carousel, Slide } from 'vue-carousel';

export default {
  name : 'Banner',
  data() {
    return {
      slides:[
        {
          image : require('@/assets/images/feed-a-child-3.jpg'),
          quote: 'If you can’t feed a hundred people, then feed just one.',
          author: 'Mother Teresa',
          size: ''
        },
        {
          image : require('@/assets/images/daily-feeding-1.jpg'),
          quote: 'I never look at the masses as my responsibility. I look at the individual. I can love only one person at a time. I can feed only one person at a time. Just one, one, one.',
          author: 'Mother Teresa',
          style: 'font-size:30px'
        },
        {
          image : require('@/assets/images/feed-a-child-2.jpg'),
          quote: 'When a poor person dies of hunger it has not happened because God did not take care of him or her. It has happened because neither you nor I wanted to give that person what he or she needed.',
          author: 'Mother Teresa',
          style: 'font-size:30px'
        },
        {
          image : require('@/assets/images/feed-a-child.jpg'),
          quote: 'The fight against poverty and hunger must be fought constantly and on many fronts, especially in its causes.',
          author: 'Pope Francis',
          style: 'font-size:40px'
        },
        {
          image : require('@/assets/images/banner1.jpg'),
          quote: 'Many things can wait. Children cannot. Today their bones are being formed, their blood is being made, their senses are being developed. To them we cannot say `tomorrow`. Their name is today.',
          author: 'Mother Teresa',
          style: 'font-size:30px'
        },
        {
          image : require('@/assets/images/banner2.jpg'),
          quote: 'If you want to eliminate hunger, everybody has to be involved.',
          author: 'Bono',
          style: ''
        },
        {
          image : require('@/assets/images/banner3.jpg'),
          quote: 'Pay attention to the hungry, both in this country and around the world. Pay attention to the poor. Pay attention to our responsibilities for world peace. We are our brother’s keeper…',
          author: 'George McGovern',
          style: 'font-size:30px'
        },
        {
          image : require('@/assets/images/banner4.jpg'),
          quote: 'If we can conquer space, we can conquer childhood hunger.',
          author: 'Buzz Aldrin',
          style: ''
        },
      ]
    }
  },
  components : {
	  Carousel,
    Slide,
  }
}
